define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/table/Widget",
	"csi/xml",
	"csi/xml/Query"
], function(declare,_,Widget,xml,Query) {

	return declare(Widget, {
		_resolveView: function() {
			this.inherited(arguments);
			
			var	nodes = this.m_formData && this.m_formData.getAggregatedNodes();
			if (nodes && nodes.length) {
				var	q = new Query();
		        
		        _.each(nodes, function(node) {
					q.Node(xml.PROP_NAME, xml.OP_NOT_EQUALS, node.$Name);
				});
				
				this.relRoot.addQuery(q);
			}
		}
	});
});